import { TourBuilderStore } from '../TourBuilderLibrary/domain/tourBuilderStore';
import { KitIconHelper } from '../TourBuilderLibrary/domain/types/KitIcon';
import {Scene, SceneGuid, SceneHelper} from '../TourBuilderLibrary/domain/types/Scene';
import { SceneLink, SceneLinkGuid } from '../TourBuilderLibrary/domain/types/SceneLink';

import { isVirtualTourIconId } from '@ael/virtual-tour-icon-bundle';
import {InMemoryStorageClient} from "./InMemoryStorageClient";
import {TourDto} from "../config/configs";

type PublicOnly<T> = {
  [K in keyof T]: T[K] extends (...args: any[]) => any ? T[K] : never;
};

export type ITourBuilderStorageClient = PublicOnly<InMemoryStorageClient>;

export function convertToStoreForStudent(toConvert: TourDto): Partial<TourBuilderStore> {
  const initState: Partial<TourBuilderStore> = {
    scenes: new Map<SceneGuid, Scene>(),
    scenesById: [],
    links: new Map<SceneLinkGuid, SceneLink>(),
  };

  toConvert.tourScenes.forEach((s) => {
    const sceneGuid: SceneGuid = s.guid as SceneGuid;
    const linkGuids: SceneLinkGuid[] = [];

    const renderSettings = s.tourScenePanorama ? {
      startingSceneIndex: s.tourScenePanorama.startingSceneIndex,
      xmlDefinition: s.tourScenePanorama.xmlDefinition,
      urlSuffix: s.tourScenePanorama.urlSuffix,
      baseDir: s.tourScenePanorama.baseDir,
    } : SceneHelper.getDefaultRenderSettings();

    const sceneToSet: Scene = {
      name: 'Unknown',
      thumbnailUrl: null,
      guid: s.guid as SceneGuid,
      sceneProcessingState: 'success',
      renderSettings,
      linkGuids: linkGuids,
    };
    initState.scenes?.set(sceneGuid, sceneToSet);
    initState.scenesById?.push(sceneGuid);

    s.links.forEach((l) => {
      const linkGuid: SceneLinkGuid = l.guid as SceneLinkGuid;
      linkGuids.push(linkGuid);
      if (!l.position) {
        throw Error('Cannot be without position.');
      }

      const icon =
        l.icon?.identifier && isVirtualTourIconId(l.icon.identifier)
          ? KitIconHelper.create({
              kitIconId: l.icon.identifier,
              scale: l.icon.scale,
            })
          : KitIconHelper.createDefault();

      const linkToSet: SceneLink = {
        guid: linkGuid,
        destinationTourSceneGuid: l.tourSceneDestinationGuid as SceneGuid,
        originTourSceneGuid: l.tourSceneOriginGuid as SceneGuid,
        position: l.position,
        icon,
        destinationLabel: l.destinationLabel ?? undefined,
        hasTilt: l.hasTilt ?? true,
      };
      initState.links?.set(linkGuid, linkToSet);
      sceneToSet.linkGuids.push(linkGuid);
    });
  });

  return initState;
}